import axios from 'axios';
import { useState } from 'react';
import validator from "validator";

const Contact = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState(false);
  const [validEmail, setValidEmail] = useState(true);

  const handleInput = (e) => {
    e.preventDefault()
    let targetName  = e.target.name;
    let targetValue = e.target.value;

    if( targetName === 'name'){
      setName(targetValue)
    }

    if(targetName === 'email'){
      if (validator.isEmail(targetValue) || targetValue.length >= 0){
        setValidEmail(true)
        setEmail(targetValue)
      }
    }

    if( targetName === 'message'){
      setMessage(targetValue)
    }

    if(targetValue.length === 0){
      setError(true);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if(!validator.isEmail(email)){
      setEmail('')
      setValidEmail(false)
    }else{
      axios.post(`/contacts`, null, { params: { 
        contact: {
          name: name,
          email: email,
          message: message
        }
      }})
      .then(res => {
        if (res.status === 200) {
          setName("");
          setEmail("");
          setMessage("");
          window.location.href = window.location.origin
        }
      }).catch(err => {
        alert('Something went Wrong....Retry Later');
      })
    }
  }

  return (
    <div className="form-box" id='contact-me'>
      <h1>Contact Me</h1>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input onChange={e=>handleInput(e)} className="form-control" style={ (error && name.length <= 0) ? {border: "3px solid red"} : {border: "none"}} id="name" type="text" name="name" placeholder='Name' />
        </div>
        <div className="form-group">
          <input onChange={e=>handleInput(e)} className="form-control" style={(error && email.length <= 0) || (!validEmail) ? {border: "3px solid red"} : {border: "none"} } id="email" type="email" name="email" placeholder='Email' />
        </div>
        <div className="form-group mb-3 textarea_div">
          <textarea onChange={e=>handleInput(e)} className="form-control" style={ (error && message.length <= 0) ? {border: "3px solid red"} : {border: "none"}} id="message" name="message" placeholder='Write Your Comment'></textarea>
        </div>
        <input className="btn btn-primary mt-0" type="submit" value="Submit"/>
      </form>
    </div>
  );
};


export default Contact;
